import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { endpoints } from '../_config/endpoint';
import {
  DashboardFilter,
  InitialDashboardFilter,
} from '../interfaces/dashboard.interface';

@Injectable({
  providedIn: 'root',
})
export class DepartmentService {
  constructor(private http: HttpClient) {}
  createDepartment(payload) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.createDepartment}`,
      payload
    );
  }

  updateteDepartment(id, payload) {
    return this.http.put(
      `${environment.API_URL_V1}/${endpoints.updateDepartment}/${id}`,
      payload
    );
  }

  getAllDepartments(filterParam?: DashboardFilter) {
    console.log(environment);
    if (!filterParam) {
      filterParam = InitialDashboardFilter;
    }

    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.getAllDepartments}`,
      filterParam
    );
  }

  deleteDepartment(departmentId) {
    return this.http.delete(
      `${environment.API_URL_V1}/${endpoints.deleteDepartment}/${departmentId}`
    );
  }
}
